module.exports = __webpack_public_path__ + "img/index2.857b720b.png";